module.exports = __webpack_public_path__ + "img/mediator-diplomat-4.d97b02e6.svg";